const formatMoney = (value) => {
  return `R$ ${Number(value).toFixed(2).replace('.', ',')}`;
}

export default formatMoney;